export default __webpack_public_path__ + "static/media/template21.2fe43079.svg";